import React from 'react';
import { Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();

  const handleGoHome = () => {
    if (isAuthenticated && user) {
      const home = user.role === 'admin' ? '/admin' : user.role === 'instructor' ? '/instructor' : '/student';
      navigate(home);
    } else {
      navigate('/login');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
      }}
    >
      <Typography variant="h3" color="text.secondary">
        404
      </Typography>
      <Typography variant="h5">Page Not Found</Typography>
      <Button variant="contained" onClick={handleGoHome}>
        Go Home
      </Button>
    </Box>
  );
};

export default NotFoundPage;
